import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import store from '../store'

Vue.use(VueRouter)

const routes = [
  { path: '/', name: 'Home', component: Home, props: true },
  { path: '/:process', name: 'Object_Home', component: Home, props: true },
  { path: '/:process/:verb', name: 'Object_New', component: Home, props: true },
  { path: '/:process/:verb/:recordid', name: 'Object_Detail', component: Home, props: true },
]

const router = new VueRouter({
  routes
})

// Funzione per verificare se l'utente ha accesso a un processo specifico
function isProcessAuthorized(process) {
  // Se non c'è un processo specifico o è la home, consenti l'accesso
  if (!process || process === '/' || process === 'logout=true') return true;
  
  // Ottieni la configurazione del processo
  const processConfig = store.getters.getProcess(process);
  if (!processConfig) return false;
  
  // Verifica se il processo ha una proprietà apps per il controllo dell'autorizzazione
  if (!processConfig.apps) return true;
  
  // Verifica se l'utente ha un profilo e team
  const myprofile = store.state.myprofile;
  if (!myprofile || !myprofile.teams) return false;
  
  // Controlla se almeno uno dei team dell'utente ha un'app abilitata che corrisponde a una delle app del processo
  return myprofile.teams.some(team => {
    if (!team.Team__r || !team.Team__r.App_abilitata__c) return false;
    
    // Controlla se l'app abilitata del team è inclusa nelle app del processo
    // O se il processo include 'default' (che lo rende accessibile per tutti i team con qualsiasi App_abilitata__c)
    return processConfig.apps.includes(team.Team__r.App_abilitata__c) || processConfig.apps.includes('default');
  });
}

// Aggiungi la guardia di navigazione globale
router.beforeEach(async (to, from, next) => {
  // Assicurati che il profilo utente sia caricato 
  if (!store.state.myprofile && store.getters.connection_id) {
    try {
      const res = await store.dispatch('myprofile');
      store.commit('SET_USER_ID', res.myprofile.user);
    } catch (error) {
      console.error('Errore nel caricamento del profilo utente:', error);
      // Se non è possibile caricare il profilo, reindirizza alla home
      next('/');
      return;
    }
  }
  
  // Ottieni il processo dalla rotta
  const process = to.params.process;
  console.log('processo: '+ process)
  
  // Verifica l'autorizzazione per il processo
  if (isProcessAuthorized(process)) {
    next(); // Autorizzato, continua la navigazione
  } else {
    console.warn(`Accesso non autorizzato al processo: ${process}`);
    // Reindirizza alla home o a una pagina di errore
    next('/');
  }
});

export default router
